module.exports = __webpack_public_path__ + "static/img/274.582cf69.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/news/274.png
// module id = 268Z
// module chunks = 0